export const RouteConstants = {
  empty: '',
  wildCard: '**',
  baseUrl: '/ignite-your-tv/',
  baseLangPath: '/assets/i18n/',
  enableBrandSelection: true,
  activate: {
    self: 'activate',
  },
  login: {
    self: 'login',
  },
  accountSelection: {
    self: 'accounts',
  },
  external: {
    login: {
      rogers: '/consumer/profile/signin',
      shaw: 'https://activate.shaw.ca/'
    },
    support: 'https://www.rogers.com/support/tv-streaming/about-the-rogers-xfinity-stream-app'
  }
};
